import Env from '../config/envConfig'

import {
  NetworkStatisticsApi as NetworkStatisticsApiClass,
  Configuration as SMConfiguration,
  FacebookPostApi as FacebookPostApiClass,
  InstagramPostApi as InstagramPostApiClass,
  IntervalStatisticsApi as IntervalStatisticsApiClass
} from '@3m5/sm_publish-frontend-api'
import smModuleFetchApi from './smModuleFetchApi'
import customFetchApi from './customFetchApi'
import {
  EditorStatisticsApi as EditorStatisticsApiClass,
  DefaultApi as DefaultApiClass,
  Configuration,
} from '@professocialApi/professocial-core-frontend-api'
import { PostTemplateApi as PostTemplateApiClass } from '@3m5/sm_publish-frontend-api'

const BASE_PATH_API = Env.restBase

export const NetworkStatisticsApi = new NetworkStatisticsApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const EditorStatisticsApi = new EditorStatisticsApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const DefaultApi = new DefaultApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const FacebookPostApi = new FacebookPostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const IntervalStatisticsApi = new IntervalStatisticsApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const InstagramPostApi = new InstagramPostApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const PostTemplateApi = new PostTemplateApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

